import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import './icofont.min.css';
import App from './App';

import { BrowserRouter as Router } from "react-router-dom";

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);


reportWebVitals();